import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import UserRegistrationForm from "../components/UserRegistrationForm";
import { calculateIntelligenceTypes } from "../services/testCalculations";
import { sendTestResultsEmail } from "../services/emailService";
import { exportToExcel } from "../services/excelService";

const questions = [
  "Я умело работаю с любыми предметами руками.",
  "У меня хорошее чувство навигации: с легкостью найду путь без карты, со мной сложно заблудиться.",
  "У меня есть естественная способность решать споры между друзьями.",
  "Я могу легко запоминать слова песен.",
  "Я могу объяснять темы, которые другим объяснять тяжело.",
  "Я всегда делаю все поэтапно.",
  "Я считаю себя физически выносливым человеком.",
  "Я стараюсь использовать натуральные и органические продукты.",
  "Всегда печатаю со скоростью и точностью.",
  "Я хорошо знаю себя и всегда понимаю, почему я поступаю так, а не иначе.",
  "Мне нравится работа с общественностью и общественные мероприятия.",
  "Я хорошо учусь, слушая других.",
  "Когда я слушаю музыку, у меня меняется настроение.",
  "Мне нравятся загадки, кроссворды, логические задачи.",
  "Для моего обучения очень важно визуальное представление материала: таблицы, графики, схемы.",
  "Я чувствителен(-а) к настроению и переживаниям окружающих.",
  "Я учусь лучше, когда мне что-то нужно делать самостоятельно.",
  "Перед тем, как учить что-то, мне нужно понимать, что в этом есть что-то нужное.",
  "Я катаюсь на велосипеде с чувством равновесия.",
  "Я люблю одиночество и тишину во время работы и размышлений.",
  "Я люблю находиться на природе и любоваться растениями.",
  "В сложных музыкальных произведениях я могу на слух вычленить отдельные музыкальные инструменты.",
  "Я точно режу ножницами.",
  "Я могу зрительно легко представить сцены, которые я помню или которые я придумал.",
  "У меня богатый словарный запас.",
  "Я люблю делать записи, письменные зарисовки.",
  "Я иногда заглядываю в детали и часто вижу элементы, которые другие пропускают",
  "У меня хорошее чувство равновесия, я люблю движение.",
  "Я могу видеть закономерности между понятиями и явлениями.",
  "В команде я сотрудничаю с другими, прислушиваюсь к их идеям.",
  "Я наблюдателен и часто вижу то, что не видят другие.",
  "Меня легко вывести из себя.",
  "Я люблю работать и учиться отдельно от других.",
  "Я люблю сочинять музыку.",
  "Я могу оперировать числами и решать сложные математические задачи.",
  "Я люблю экскурсии и различные физически-активные мероприятия.",
  "Я хорошо работаю с инструментами.",
  "Я хорошо играю в шахматы.",
  "У меня есть интерес к природным явлениям.",
  "Я ремонтирую вещи своими руками.",
  "Я легко начинаю разговор с незнакомыми людьми.",
  "У меня отличная координация в движениях.",
  "Я люблю читать.",
  "Я представляю идеи визуальными или символическими способами.",
  "Я легко влияю на других людей.",
  "Я люблю различные растения и мне нравится ухаживать за ними.",
  "Я потрясающе решаю проблемы.",
  "Я обладаю отличным чувством ритма и поддерживаю его.",
  "Я легко изучаю новые языки.",
  "Я иногда занимаюсь самоанализом.",
  "Я аккуратно складываю одежду и бумагу.",
  "Я стремлюсь окружить себя растениями и зеленью.",
  "Я хорошо рисую и раскрашиваю с точностью.",
  "Я нахожу символизм в музыке и способен(-на) выражать идеи и чувства через звук и музыку.",
  "Я ремонтирую вещи, когда они ломаются.",
  "Я выражаю мысли и чувства через письмо.",
  "Я обладаю острым чувством сочетания цветов.",
  "Во время разговора я постоянно двигаюсь и жестикулирую.",
  "Мне нравятся различные методы исследования гипотез и теории объяснения явлений.",
  "Слушая других, я делаю зарисовки (каракули) на листе.",
  "У меня большой круг друзей.",
  "Я размышляю о своих целях и достижениях, мне важна личная эффективность.",
  "Я могу долго выполнять мелкую работу руками.",
  "Я понимаю правила грамматики и следую им.",
  "Я переживаю и нервничаю, когда загрязняют окружающую среду.",
  "Я легко думаю в картинках и образах.",
  "Я понимаю причину и следствие событий, информации.",
  "Я визуализирую вещи в трех измерениях.",
  "Я использую интонацию в своем голосе, разговаривая с окружающими.",
  "Я понимаю мотивы людей.",
  "Я разбираю предметы на части и собираю их обратно.",
  "Я различаю различные виды живых существ, растений.",
  "Я просматриваю, обрабатываю информацию и легко перевожу ее из воображения в реальность.",
  "Я имею представление о сложностях себя и других, поощряю самопонимание.",
  "Я экономлю место при упаковке и хранении вещей.",
  "Я демонстрирую легкость в письменной и устной речи.",
  "Я могу соединить различные фрагменты информации.",
  "Моя ловкость рук позволяет хорошо выполнять работу с мелкими деталями.",
  "Я придумываю разные новые танцевальные (спортивные) движения.",
  "У меня хорошее чувство цвета, света и тени.",
  "Я легко вижу, как все сочетается друг с другом.",
  "Я играю на музыкальном инструменте.",
  "Я думаю в основном с точки зрения других людей.",
  "Я способен(-на) контролировать себя физически, эмоционально и/или духовно.",
  "Я могу слушать музыку в своей голове, даже когда она не играет вокруг меня.",
  "Я наслаждаюсь проведением времени на свежем воздухе.",
  "Я ловко исполняю любые физические действия.",
  "У меня развито чувство меры и дистанции.",
  "Я интересуюсь более глубокими вопросами в жизни, включая смысл, актуальность и цель.",
  "Мне нравятся естественные науки о жизни (биологические, физические, химические)."
];

const IntelligenceTypesTest = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [currentValue, setCurrentValue] = useState('');
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    email: "",
    phone: ""
  });
  const [isStarted, setIsStarted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedAnswers = localStorage.getItem('intelligenceTypesAnswers');
    if (savedAnswers) {
      setAnswers(JSON.parse(savedAnswers));
    }
    // Инициализируем currentValue для первого вопроса
    setCurrentValue(answers[1]?.toString() || '');
  }, []);

  const handleStart = () => {
    setIsStarted(true);
  };

  const handleAnswerChange = (value) => {
    // Заменяем запятую на точку
    const normalizedValue = value.replace(',', '.');
    setCurrentValue(normalizedValue);
    
    // Валидация: проверяем, что значение находится в диапазоне 0-2
    const numValue = parseFloat(normalizedValue);
    if (!isNaN(numValue) && numValue >= 0 && numValue <= 2) {
      setAnswers({
        ...answers,
        [currentQuestion + 1]: numValue
      });
    } else if (normalizedValue === '' || normalizedValue === '0' || normalizedValue === '1' || normalizedValue === '2') {
      // Разрешаем пустое значение и целые числа
      setAnswers({
        ...answers,
        [currentQuestion + 1]: parseFloat(normalizedValue) || 0
      });
    }
  };

  const isValidValue = (value) => {
    const normalizedValue = value.replace(',', '.');
    const numValue = parseFloat(normalizedValue);
    return !isNaN(numValue) && numValue >= 0 && numValue <= 2;
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Return') {
      if (currentValue && currentValue !== '' && isValidValue(currentValue) && !isLastQuestion) {
        nextQuestion();
      } else if (currentValue && currentValue !== '' && isValidValue(currentValue) && isLastQuestion) {
        submitTest();
      }
    }
  };

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setCurrentValue(answers[currentQuestion + 2]?.toString() || '');
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      setCurrentValue(answers[currentQuestion]?.toString() || '');
    }
  };

  const submitTest = async () => {
    setIsSubmitting(true);
    try {
      // Calculate results on frontend
      const testResult = calculateIntelligenceTypes(answers);
      testResult.userInfo = userInfo;
      testResult.testType = 'intelligence_types';
      
      // Send email with detailed results and Excel attachment
      const emailResult = await sendTestResultsEmail(testResult, 'intelligence_types');
      
      if (emailResult.success) {
        console.log('✅ Email sent successfully');
        if (emailResult.excelCreated) {
          console.log(`📊 Excel file created: ${emailResult.excelFileName}`);
        }
      } else {
        console.error('❌ Email sending failed:', emailResult.error);
      }
      
      // Создаем Excel файл для скачивания (для тестирования)
      const excelResult = exportToExcel(testResult);
      if (excelResult.success) {
        console.log(`📁 Excel file created: ${excelResult.fileName}`);
      } else {
        console.error('❌ Excel creation failed:', excelResult.error);
      }
      
      // Store results for display (only basic info)
      const displayResult = {
        id: Date.now().toString(),
        test_type: 'intelligence_types',
        user_info: userInfo,
        results: {
          categories: testResult.allCategories,
          top_types: testResult.topTypes,
          summary: testResult.summary
        },
        timestamp: new Date().toISOString()
      };
      
      // Store in localStorage for display
      localStorage.setItem('lastTestResult', JSON.stringify(displayResult));
      
      // Navigate to thank you page instead of results
      navigate('/thank-you');
      
    } catch (error) {
      console.error("Error submitting test:", error);
      alert("Ошибка при отправке результатов. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isStarted) {
    const testDescription = (
      <div>
      <div className="mb-6 p-4 bg-green-50 rounded-md">
        <h3 className="font-semibold text-green-800 mb-2">О тесте:</h3>
        <p className="text-green-700 text-sm mb-2">
          Анкета по типам интеллекта позволяет выявить вашу склонность к тому или иному типу деятельности, 
          что может помочь вам в выборе будущей профессии.
        </p>
        <p className="text-green-700 text-sm mb-2">
          Анкета основана на взглядах о структуре интеллекта, изложенных в теории Г. Гарднера.
        </p>
      </div>
        <div className="mb-6 p-4 bg-yellow-50 rounded-md">
          <h4 className="font-semibold text-yellow-800 mb-2">Инструкция:</h4>
          <p className="text-yellow-700 text-sm mb-1">Отметьте номера утверждений, которые Вам соответствуют цифрами от 0 до 2.</p>
          <ul className="text-yellow-700 text-sm space-y-1">
            <li>• Если полностью согласны (100%) = 1</li>
            <li>• Если частично (например, 37% = 0.37, 83% = 0.83)</li>
            <li>• Если более чем уверены (до 200%, например, 1.18, 1.43, 1.79) = до 2</li>
            <li>• Если не согласны = 0</li>
          </ul>
        </div>
        </div>
    );

    return (
      <UserRegistrationForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        onStart={handleStart}
        testTitle="Анкета по типам интеллекта"
        testDescription={testDescription}
        buttonText="Начать анкету (90 вопросов)"
      />
    );
  }

  const isLastQuestion = currentQuestion === questions.length - 1;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <ProgressBar current={currentQuestion + 1} total={questions.length} className="mb-8" />
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Вопрос {currentQuestion + 1}
            </h2>
            <p className="text-gray-700 text-lg mb-6">
              {questions[currentQuestion]}
            </p>
            
            <div className="space-y-4" onKeyPress={handleKeyPress}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Введите значение от 0 до 2:
                </label>
                <input
                  type="text"
                  value={currentValue}
                  onChange={(e) => handleAnswerChange(e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:border-transparent ${
                    currentValue && currentValue !== '' 
                      ? (isValidValue(currentValue)
                          ? 'border-green-500 focus:ring-green-500' 
                          : 'border-red-500 focus:ring-red-500')
                      : 'border-gray-300 focus:ring-green-500'
                  }`}
                  placeholder="0.00 - 2.00 (например: 0.2, 1.32, 1.5)"
                />
                {currentValue && currentValue !== '' && !isValidValue(currentValue) && (
                  <p className="text-red-500 text-xs mt-1">Пожалуйста, введите значение от 0 до 2 (используйте точку как десятичный разделитель)</p>
                )}
              </div>
              
              <div className="bg-blue-50 p-3 rounded text-sm">
                <p className="text-blue-800 font-medium mb-1">Примеры значений:</p>
                <ul className="text-blue-700 space-y-1">
                  <li>• Полностью согласны (100%) = 1.00</li>
                  <li>• Частично согласны (37%) = 0.37</li>
                  <li>• Более чем уверены (118%) = 1.18</li>
                  <li>• Не согласны = 0.00</li>
                </ul>
              </div>
              
              <p className="text-xs text-gray-500 mt-2">
                Нажмите Enter для перехода к следующему вопросу
              </p>
            </div>
          </div>

          <div className="flex justify-between">
            <button
              onClick={prevQuestion}
              disabled={currentQuestion === 0}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
            
            {isLastQuestion ? (
              <button
                onClick={submitTest}
                disabled={isSubmitting || !currentValue || currentValue === '' || !isValidValue(currentValue)}
                className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Отправка..." : "Завершить анкету"}
              </button>
            ) : (
              <button
                onClick={nextQuestion}
                disabled={!currentValue || currentValue === '' || !isValidValue(currentValue)}
                className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Далее
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntelligenceTypesTest;